import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import { candidateResultColumnsConfig } from "../config/CandidateResult";
import { ConfirmPopup } from "../Confirmation";
import { useNavigate } from "react-router-dom"; 
import { getCandidateResultWithFilter } from "../../../slices/thunks";

export const getCandidateResultColumns = ({ onDeleteClick, onEditClick,handleRowClick  }) => {
  const [confirmOpenForId, setConfirmOpenForId] = useState(null);
 
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // useEffect(() => {
  //   dispatch(getCandidateResultWithFilter())
  //     .then((res) => {
  //       const resultList = Array.isArray(res.payload?.data)
  //         ? res.payload.data
  //         : [];
  //       setCandidateResults(resultList);
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching candidate results:", err);
  //       setCandidateResults([]);
  //     })
  //     .finally(() => setLoading(false));
  // }, [dispatch]);

 
  return [
  
    {
      name: <span className="font-weight-bold fs-13">{candidateResultColumnsConfig.NAME}</span>,
      selector: (row) => row.name ,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{candidateResultColumnsConfig.EMAIL}</span>,
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{candidateResultColumnsConfig.TOTQUESTION}</span>,
      selector: (row) => row.total_questions,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{candidateResultColumnsConfig.CORRECTANS}</span>,
      selector: (row) => row.correct_answers,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">{candidateResultColumnsConfig.SCORE}</span>,
      selector: (row) => row.score,
      sortable: true,
    },
     
    {
      name: <span className="fw-bold fs-13">{candidateResultColumnsConfig.STATUS}</span>,
      selector: (row) => (
        <span className={`fw-semibold ${row.status === "Passed" ? "text-success" : "text-danger"}`}>
          {row.status === "Passed" ? "Passed" : "Failed"}
        </span>
      ),
      // sortable: true,
    },
    
    {
      name:  <span className="fw-bold fs-13">{candidateResultColumnsConfig.ACTION}</span>,
      cell: (row) => (
        <a
          className="fs-13 nav-link p-2"
          onClick={() => handleRowClick(row)} // pass full row or just row.id
        >
          <i className="ri-eye-fill fs-20 p-1  cursor-pointer bg-soft-primary text-primary rounded-circle align-middle"></i>
        </a>
      ),
    },
  ];
};





